//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        blok: {
            type: Object,
            default: () => { }
        }
    },
    methods: {
        goBack() {
            this.$router.go(-1)
        }
    }
}
